import { JBaseApi } from '../base';
import {
    ApiWrapper,
    DriveAccount,
    DriveGetAccount,
    DriveGetAccountParams,
    DriveGetDocumentParams,
    MSGetDocumentsParams,
    DriveGetGroupsParams,
    DriveGetTenantsParams,
    DriveLogoutParams,
    DriveSetDefaultAccountParams,
    FormatList,
    jFileLittle,
    MSDocumentEntity,
    MSGroupEntity,
    MSSiteEntity,
    MSTenantEntity,
    DropboxDocumentEntity,
    DropboxGetDocumentsParams,
} from '../../types';
import { OF } from '../../util/network';

export class JDriveApi extends JBaseApi {
    /**
     * Microsoft graph only
     * @returns
     */
    public tenants(
        params?: DriveGetTenantsParams,
        options?: {
            signal?: AbortSignal;
        },
    ): Promise<ApiWrapper<MSTenantEntity[]>> {
        return this.network.post(
            {
                o: 'drive',
                f: 'getTenants',
                ...(params ?? {}),
            } as OF,
            options?.signal,
        );
    }

    /**
     * Microsoft graph only
     * @returns
     */
    public groups(
        params: DriveGetGroupsParams,
        options?: {
            signal?: AbortSignal;
        },
    ): Promise<ApiWrapper<MSGroupEntity[]>> {
        return this.network.post(
            {
                o: 'drive',
                f: 'getGroups',
                ...params,
            } as OF,
            options?.signal,
        );
    }

    /**
     * Microsoft graph only
     * @returns
     */
    public sites(options?: { signal?: AbortSignal }): Promise<ApiWrapper<MSSiteEntity[]>> {
        return this.network.post(
            {
                o: 'drive',
                f: 'getSites',
            } as OF,
            options?.signal,
        );
    }

    public listAccount(service: string, options?: { signal?: AbortSignal }): Promise<ApiWrapper<DriveAccount[]>> {
        return this.network.post(
            {
                o: 'drive',
                f: 'listAccount',
                service,
            } as OF,
            options?.signal,
        );
    }

    public isAccountLogged(
        service: string,
        id: string,
        options?: {
            signal?: AbortSignal;
        },
    ): Promise<ApiWrapper<boolean>> {
        return this.network.post(
            {
                o: 'drive',
                f: 'isAccountLogged',
                service,
                id,
            } as OF,
            options?.signal,
        );
    }

    public checkAccountToken(service: string, options?: { signal?: AbortSignal }): Promise<ApiWrapper<boolean>> {
        return this.network.post(
            {
                o: 'drive',
                f: 'checkAccountToken',
                service,
            } as OF,
            options?.signal,
        );
    }

    public msDocuments(
        params: MSGetDocumentsParams,
        options?: {
            signal?: AbortSignal;
        },
    ): Promise<ApiWrapper<MSDocumentEntity[]>> {
        return this.network.post(
            {
                o: 'drive',
                f: 'getDocuments',
                service: 'onedrive',
                ...params,
            } as OF,
            options?.signal,
        );
    }

    public dropboxDocuments(
        params: DropboxGetDocumentsParams,
        options?: {
            signal?: AbortSignal;
        },
    ): Promise<ApiWrapper<DropboxDocumentEntity[]>> {
        return this.network.post(
            {
                o: 'drive',
                f: 'getDocuments',
                service: 'dropbox',
                ...params,
            } as OF,
            options?.signal,
        );
    }

    public getDocument<T extends jFileLittle = jFileLittle>(
        params: DriveGetDocumentParams,
        options?: {
            signal?: AbortSignal;
            format?: FormatList;
        },
    ): Promise<ApiWrapper<T>> {
        return this.network.post(
            {
                o: 'drive',
                f: 'getDocument',
                ...params,
                format: options?.format ?? 'raw-little',
            } as OF,
            options?.signal,
        );
    }

    public logout(params: DriveLogoutParams, options?: { signal?: AbortSignal }): Promise<ApiWrapper<boolean>> {
        return this.network.post(
            {
                o: 'drive',
                f: 'logout',
                ...params,
            } as OF,
            options?.signal,
        );
    }

    public getAccount(
        params: DriveGetAccountParams,
        options?: { signal?: AbortSignal },
    ): Promise<ApiWrapper<DriveGetAccount>> {
        return this.network.post(
            {
                o: 'drive',
                f: 'get-user-data',
                ...params,
            } as OF,
            options?.signal,
        );
    }

    public setDefaultAccount(
        params: DriveSetDefaultAccountParams,
        options?: { signal?: AbortSignal },
    ): Promise<ApiWrapper<boolean>> {
        return this.network.post(
            {
                o: 'drive',
                f: 'set-has-default',
                ...params,
            } as OF,
            options?.signal,
        );
    }
}
